<template>
  <el-dialog
    :visible="dialogVisible"
    :title="selectedProduct ? selectedProduct.title : ''"
    width="80%"
    class="dialogStyle"
    top="2vh"
    @close="closeDialog"
  >
    <div v-if="selectedProduct" class="details">
      <div class="details_img">
        <div class="img">
          <img :src="selectedProduct.url1" alt="" />
        </div>
      </div>
      <div class="details_c">
        <!-- （大型 ）医用中心制氧系统 -->
        <template v-if="selectedProduct.id === 1">
          <h2>产品详情</h2>
          <p>
            医用中心制氧系统是埃珥赛璞医用气体系统中氧气系统的核心产品，它采用国际先进技术，以美国UOP最新型医用分子筛变压吸附法制取氧气，该过程为无化学反应的物理吸附过程，安全、经济、方便，是实现医疗系统现代化管理的理想供氧方式。
          </p>
          <p><strong>高效</strong></p>
          <p>
            高智能自动运行、监控、显示，操作简单方便；能实现远程检测、监控，并能实现远程维护。
          </p>
          <p><strong>严谨</strong></p>
          <p>
            整套系统设备采用不锈钢制造，唯一一家符合国家药品行业GMP标准；“生产—施工—运行”每一个过程都严格把关，保障产品质量；整个系统在低压密闭的环境中运行，安全可靠。
          </p>
          <p><strong>环保</strong></p>
          <p>
            以空气为原料，氧源安全、经济、环保；分子筛解吸器有效降低了系统运行能耗、提高氧气制取率（制取每立方医用氧仅需0.8—1.2度电）；独特的静音式设计，使周围环境噪声低于45dB（A）。
          </p>
          <p><strong>智能</strong></p>
          <p>
            采用PLC微电脑自动控制，高智能自动运行，操作安全、简单；特别研发的《医用中心制氧系统》监控软件，远程监控轻松实现；氧气纯度、流量、压力实时在线监测，支持智能声光报警。
          </p>
          <p><strong>稳定</strong></p>
          <p>
            采用国际先进的制氧技术，选用高性能的进口设备，保障系统运行稳定；设计安装时采取了一系列优化设计方案，降低耗材使用量的同时，大大提升了系统的稳定性；完善的售后服务，正常维护和使用下，可以用10年以上。
          </p>
          <p><strong>灵活</strong></p>
          <p>10余种不同型号的产品，适用于各种规模医院的用氧需求。</p>
        </template>
        <!-- 制氧主机 -->
        <template v-if="selectedProduct.id === 2">
          <h2>产品详情</h2>
          <p>
            我公司制氧机采用目前世界最新科技成果—PSA先进技术，利用分子筛压力转换吸附方式清除空气中的氮气和其他物质，以高纯度的氧气供医院使用。其制氧机获得美国联邦邦医药食品药物管理局认证，其质量于1994年获ISO认证，为国内医院引进使用，至今国内已有八百多家医院广泛使用，并得到一致好评。制氧机供氧机达到了先进国家的医用水平，具备安全、可靠、低成本的特点、符合优质、高效、低耗等优点，推荐各医院推广使用。
          </p>
          <p>
            <strong
              >氧纯度：93%±3%（V/V），符合中华人民共和国YY/T0298-1998标准。</strong
            >
          </p>
          <p>
            <strong
              >氧气输出压力范围：≥0.06Mpa，通过配备氧气增压系统，可将氧气增压到0.8Mpa，满足医院各种医疗器械用氧压</strong
            >
          </p>
        </template>
        <!-- 空压机 -->
        <template v-if="selectedProduct.id === 3">
          <h2>产品详情</h2>
          <p>√ 全电脑数字控制功能，控制面板直接调整数据。</p>
          <p>√ 自动检测并记录故障，自动报警。</p>
          <p>√ 自动控制压缩机的加速和减速运行。</p>
          <p>√ 噪音值低，≤45dB。</p>
          <p>√ 可全天24小时连续运行。</p>
        </template>
        <!-- 冷干机 -->
        <template v-if="selectedProduct.id === 4">
          <h2>产品详情</h2>
          <p>√ 输出压力露点≤3℃。</p>
          <p>√ 自动电磁排气阀。</p>
          <p>性能稳定、维护时间少、高效节能、运行可靠</p>
        </template>
        <!-- 过滤器 -->
        <template v-if="selectedProduct.id === 5">
          <h2>产品详情</h2>
          <p>
            过滤器组采用Boke生产的过滤器配套，气水分离器器壳体采用防海水腐蚀铝合金材料制造，表面阳极化处理，外表面粉末喷涂；具有较高的耐腐蚀性能，保证其使用寿命，防止压缩空气的二次污染。过滤器均配有专门设计的BEKOMAT®
            20
            FM冷凝液自动排除器，能够及时可靠地排除过滤器中积累的冷凝液，并避免压缩空气的泄露造成的能源损失；同时排除器上滤芯寿命管理系统能够监控过滤器的运行时间并自动显示更换滤芯的最佳时间，方便维护工作
          </p>
        </template>
        <!-- 纯度分析仪 -->
        <template v-if="selectedProduct.id === 6">
          <h2>产品详情</h2>
          <p>
            采用了进口高性能的氧化皓气体传感器和微处理机技术，具有数字显示、上下限报警、标准信号输出及继电器触点报警输出等功能。适用于对空气，氮气，煤气，氩气等气体中的氧气浓度连续监测。本仪器还克服了热磁式氧分析仪的许多缺点
          </p>
        </template>
        <!-- 小型医用中心供氧系统 -->
        <template v-if="selectedProduct.id === 7">
          <h2>产品详情</h2>
          <p>
            <strong><em>产品简介：</em></strong>
          </p>
          <p>
            由于社区乡村医疗点、小型医院、诊所等小型医疗场所医疗条件有限，无法像大型医院那样配备大型医用制供氧系统，传统的汇流排和液氧罐供氧方式也无法保障这些小型医疗场所的用氧需求及用氧安全。埃珥赛璞（小型）医用中心制氧机的先进技术和工艺，制氧速度快、运行成本低、使用寿命长、维护简便、操作安全、同时提供制氧主机、控制器、输氧管道、终端（包括设备带、快速接头、湿化器、吸氧头）等医用必要设备，完全可满足其医疗环境实时、安全、方便、快捷的用氧需求，从而解决了小型医疗场所“救治”、“缺氧”的重大难题。
          </p>
          <p>
            <strong><em>产品优势：</em></strong>
          </p>
          <p><strong>医疗专用 性能稳定</strong></p>
          <p>
            埃珥赛璞（小型）医用中心制氧系统是公司的大型医用制氧系统的先进技术和经验的延伸，根据医用需求，系统专门设有热循环和排水装置，
            保障了系统运行的稳定性和使用寿命。
          </p>
          <p>随意组合 灵活方便</p>
          <p>
            采用模块化设计，可根据社区乡村医疗点、小型医院、诊所等小型医疗场所的用氧情况随意叠加，自由组合。随加随用，方便快捷。（以下表格参数仅供参考，配备时根据医疗场所具体情况而定）
          </p>
          <p><strong>智能监控 远程维护</strong></p>
          <p>
            高智能自动运行、监控、显示，操作简单方便；能实现远程检测、监控，并能实现远程维护。
          </p>
          <p><strong>数字化节能设计 节能环保</strong></p>
          <p>
            <strong
              >整套系统在制氧过程中以空气为原料，仅以电能为耗材，系统采用的数字化节能设计，可根据用氧量进行自动数字化调节，节约电能。</strong
            >
          </p>
          <p><strong>增压配置支持</strong></p>
          <p>
            <strong
              >可根据医院增压用氧（呼吸机、麻醉剂等）需求，增加增压控制系统。</strong
            >
          </p>
          <p><strong>氧终端 功能齐全</strong></p>
          <p>
            吸氧终端完全满足医疗需求，功能齐全。自带控制器和计时器，控制器可直接控制出氧开关、大小、浓度，调节湿化大小。
          </p>
          <p><strong>氮气外排式设计 增加室内氧气</strong></p>
          <p>
            制氧主机上专门设计了氮气输出装置，制氧过程中产生的氮气由专用管道排至室内，使室内氮气成分下降，氧气增加。
          </p>
          <p><strong>安装简便 不占用场所空间</strong></p>
          <p>采用壁挂式安装，超薄的机型设计，单台或集成式安装都不占用空间。</p>
        </template>
        <!-- 智能控制器 -->
        <template v-if="selectedProduct.id === 8">
          <h2>产品详情</h2>
          <p>
            智能控制器：能够自动控制各台制氧主机的启停，从而保证整套系统制取的氧气压力和浓度保持在医用标准，满足医院供氧和用氧要求。一整套制氧系统可以满足于需要呼吸机、麻醉机等条件下的各类中小型具有手术能力的医疗机构。
          </p>
          <p>智能控制器</p>
          <p>电 源：AC220V 50Hz</p>
          <p>输出压力：0.5Mpa—0.8Mpa</p>
          <p>输出压力：0.5Mpa—0.8Mpa</p>
          <p>噪 音:：≦45dB（A）</p>
          <p>外形尺寸：640×1650×600（mm）</p>
        </template>
        <!-- 供氧终端3 -->
        <template v-if="selectedProduct.id === 9">
          <h2>产品详情</h2>
          <p>
            分体式吸氧终端，吸氧面板配合小型线槽，主要用于小型医院、乡镇卫生所、社区服务站
          </p>
        </template>
        <!-- 供氧终端1 -->
        <template v-if="selectedProduct.id === 10">
          <h2>产品详情</h2>
          <p>
            分体式吸氧面板终端，吸氧面板配合小型线槽，主要用于小型医院和乡镇卫生所
          </p>
        </template>
        <!-- 供氧终端2 -->
        <template v-if="selectedProduct.id === 11">
          <h2>产品详情</h2>
          <p>
            集成式设备带，终端端口更多，功能更全，属于医疗专业级别的供氧终端。
          </p>
        </template>
        <!-- 控制器 -->
        <template v-if="selectedProduct.id === 12">
          <h2>产品详情</h2>
          <p>
            主要用于需要呼吸机、麻醉机等特殊用氧条件下的各类中小型具有手术能力的基层医疗卫生机构。
          </p>
        </template>
        <!-- 气体监控系统 -->
        <template v-if="selectedProduct.id === 13">
          <h2>产品详情</h2>
          <p><strong>气源中心监控系统 </strong></p>
          <p>
            在气源中心站设置气体流量监测仪、气体压力监测仪等用来提供整个供气中心站的相关数据，经过整理分析后通过医院内网传输到中央气体集中监控终端（支持声光报警）；
          </p>
          <p><strong>管路监控系统 </strong></p>
          <p>
            在医用供气系统的二级减压装置处设置气体流量监测仪、气体压力检测仪用来提供整个医用供气系统管路的相关数据，经过整理、分析后通过医院内网传输到中央气体集中监控终端（支持声光报警）；
          </p>
          <p><strong>终端监控系统 </strong></p>
          <p>
            在医用气体终端，病房床头设备带处设置气体流量监测仪、气体压力监测仪、插拔式接口监测仪，用来监测医用气体末端的气体使用情况，保障患者的用气安全（支持声光报警）。
          </p>
        </template>
        <!-- 二级减压箱 -->
        <template v-if="selectedProduct.id === 14">
          <h2>产品详情</h2>
          <p>
            二级减压截止阀箱同时集成了管路的减压及截止功能，减压的目的就是将管道压力控制在一定的压力范围之内，如将用于病房的氧气压力控制在0.3~0.5mpa左右，将用于高压氧舱的压力控制在0.6~0.8mpa左右，而从汇流排或液氧罐输出的压力一般在0.8~1.0mpa左右。在气体使用区域内设置二级减压装置，还可以起到缓冲管道压力的作用，减轻对病人的影响，降低应用风险。负压吸引系统及agss系统不需要进行减压，而氧气、压缩空气、笑气等医用气体一般需要在管路内设置二级减压装置。
            截止功能主要实现对管道的开启和关闭功能，我公司采用线性球阀实现对管道的启闭控制。一般线性球阀安装在减压器的前方，与减压器串接在管道中。为防止减压器或线性球阀出现故障影响气体的使用，一般在气体管路上还需要加装支路（负压系统及agss系统不需要支路），一旦减压器或与减压器串接的线性球阀出现故障，将开启支路上的线性球阀，以保证气体可以持续供应。
          </p>
        </template>
        <!-- 负压管道 -->
        <template v-if="selectedProduct.id === 15">
          <h2>产品详情</h2>
          <p>
            负压吸引系统管道主管路和楼层内部的管道多采用镀锌钢管，也可采用不锈钢管连接，入户管一般采用不锈钢管或紫铜管。镀锌钢管连接处使用螺纹连接，用聚四氟乙烯填料，不锈钢管采用氩弧焊焊接，铜管采用钎焊焊接。
          </p>
        </template>
        <!-- 负压吸引终端 -->
        <template v-if="selectedProduct.id === 16">
          <h2>产品详情</h2>
          <p>
            引进纳米抗菌技术，配置无级调节旋钮、兼容性接头装置、1-5L不同容量吸引瓶，其结构简单，方便拆卸和清洗、消毒。
          </p>
        </template>
        <!-- 管道接头 -->
        <template v-if="selectedProduct.id === 17">
          <h2>产品详情</h2>
          <p>用于管道与管道之间的连接</p>
        </template>
        <!-- 空气压缩机组 -->
        <template v-if="selectedProduct.id === 18">
          <h2>产品详情</h2>
          <p><strong>系统优势 </strong></p>
          <p>1、性能稳定、噪音小、耗能低；</p>
          <p>2、无需基础，可直接安装；</p>
          <p>3、故障率低、终身维护，有完善的售后服务保障。</p>
          <p><strong>设备、技术 </strong></p>
          <p>
            1、采用螺杆空压机或无油活塞空压机，搭配成套干燥过滤设备及气体分析设备，完全符合医用空气要求，有效保障客户用气品质。
          </p>
          <p>
            2、监控电脑实现系统全自动控制、集成报警、USP不间断电源等，保证系统稳定高效运行。
          </p>
          <p>
            3、系统符合医疗行业国际最高标准NFPA-99及HTM02-01相关规定，有效保障用气安全。
          </p>
        </template>
        <!-- 其他气体 -->
        <template v-if="selectedProduct.id === 19">
          <h2>产品详情</h2>
          <p>
            埃珥赛璞其它医用气体系统包含氮气、笑气、二氧化碳、麻醉废气排放等，全方位满足医院手术对各种医用的需求。
          </p>
        </template>
        <!-- 设备带 -->
        <template v-if="selectedProduct.id === 20">
          <h2>产品详情</h2>
          <p>
            医院病房内，可以装载气体终端、电源开关和插座等设备。它是中心供氧以及中心吸引系统的必不可少的气体终端控制装置。
          </p>
          <p>设备带都具备以下特点：</p>
          <p>1. 铝合金材质喷塑表面处理，外表美观、耐磨、易清洁</p>
          <p>2. 有单腔、双腔两种结构</p>
          <p>3. 气体终端带透明罩</p>
          <p>4. 电路气路分离型双通道，安全可靠</p>
          <p>5. 安装、维修方便</p>
          <p>6. 颜色可按用户要求定制</p>
          <p>7. 气体管道经过100%气密性测试</p>
          <p>
            8.
            可装载多种电气设备及气体插座，包括照明灯、阅读灯、特殊用途灯、电源插座、电话或网络插座、电气开关、医用气体插座、护士呼叫系统等
          </p>
        </template>
        <!-- 压缩空气管道 -->
        <template v-if="selectedProduct.id === 21">
          <h2>产品详情</h2>
          <p>
            气站和主管道主要采用镀锌钢管，病房内的支管采用不锈钢管和铜管。连接处镀锌钢管用螺纹连接，用聚四氟乙烯填料。
          </p>
        </template>
        <!-- 压缩空气终端 -->
        <template v-if="selectedProduct.id === 22">
          <h2>产品详情</h2>
          <p>
            终端采用快速自封插拔式接头，插拔方便，连接密封可靠，终端还设有防错插结构，以保证医院用气安全。自带维修阀，压缩空气终端维修时不影响其他终端使用。
          </p>
        </template>
        <!-- 氧气管道 -->
        <template v-if="selectedProduct.id === 23">
          <h2>产品详情</h2>
          <p>
            氧气管道主要采用不锈钢管和脱氧紫铜管，连接处不锈钢管采用氩弧焊焊接，脱氧紫铜管采用钎焊焊接。
          </p>
        </template>
        <!-- 氧气终端 -->
        <template v-if="selectedProduct.id === 24">
          <h2>产品详情</h2>
          <p><strong>氧气接头</strong></p>
          <p>采用快速自封插拔式接头，插拔方便，联接密封可靠。</p>
          <p><strong>氧气湿化器</strong></p>
          <p>
            主体减压器采用铝合金材质，配上高精度控制阀、高清晰流量指示管，瓶身采用高质量耐压透明聚脂材料制造。根据医院的需求，可提供不同的造型；
          </p>
          <p><strong>设备带</strong></p>
          <p>
            埃珥赛璞医工根据医院不同病房的不同功能需求，推出了常用普通、壁画、多功能柱、桥架等多款不同形式的设备带。
          </p>
        </template>
        <!-- 真空机组 -->
        <template v-if="selectedProduct.id === 25">
          <h2>产品详情</h2>
          <p><strong>优势：</strong></p>
          <p>1、真空度稳定、耗能低、噪音小、效率高、维修方便；</p>
          <p>2、无需基础，安装方便，整体集成，占地面积小；</p>
          <p>3、故障率低、终身维护，有完善的售后服务保障。</p>
          <p><strong>设备、技术</strong></p>
          <p>1、真空泵站内采用射流式真空泵或高效水环式真空泵组作为负压源；</p>
          <p>
            2、电控柜可采用PLC或者单片机自动控制真空泵交替循环工作，真空泵的启动与停止采取自动控制；
          </p>
          <p>3、智能显示真空度数字，可对病区负压值进行检测，自动报警功能。</p>
        </template>
        <!-- （大型）医用中心制氧系统 -->
        <template v-if="selectedProduct.id === 26">
          <h2>产品详情</h2>
          <p><strong>产品简介：</strong></p>
          <p>
            埃珥赛璞医用中心制氧系统是采用国际先进水平加拿大O2&O3
            公司PSA技术，用美国UOP最新型医用分子筛，以医用分子筛变压吸附法制取氧气，该过程为物理吸附过程，无化学反应，其安全性、环保性等是实现医疗系统现代化管理的理想供氧方式。
          </p>
          <p><strong>优势：</strong></p>
          <p>
            <strong>简便性：</strong
            >埃珥赛璞实现智能监控、自动运行，无需经常调校，压缩机正常使用下7-10年维护一次；系统制取的氧气直接直接进入医院中心供氧系统，实现医院制氧、供氧一体化，使医院用氧管理科学化、现代化。
          </p>
          <p>
            <strong>安全性：</strong
            >埃珥赛璞制氧机在常温低压（20-40℃，4-6个大气压）下工作，不存在原理方面的不安全因素；整个系统在低压密闭的环境中运行，氧气纯度、流量、压力在线监测，安全可靠。
          </p>
          <p>
            <strong>经济性：</strong
            >埃珥赛璞医工制氧机以空气为原料，安全可靠，成产成本低，仅以电为耗能。制取每立方医用氧仅需：0.8-1.2度电，低能耗是同类产品不可比的。
          </p>
          <p><strong>设备、技术</strong></p>
          <p>
            埃珥赛璞医用中心制氧系统选用高性能进口设备，采用国际先进水平加拿大O2&O3
            公司PSA技术来制取富氧空气，符合国家GMP生产要求。该系统通过压缩机对压缩空气进行处理后，采用美国UOP最新型医用分子筛以医用分子筛变压吸附法制取氧气来完成医院的供氧。
          </p>
          <p>
            1、采用加拿大国际先进水平O2&O3公司的PSA技术和先进的系统设计，选用进口设备和高性能配置，使整个系统运行稳定。
          </p>
          <p>
            2、该系统采用PLC微电脑自动控制，高智能自动运行，操作安全、简单，无需专人值班管理，节省大量人力物力。
          </p>
          <p>
            3、该系统以空气为原料，采用美国UOP最新型医用分子筛，以医用分子筛变压吸附法制取氧气，氧气纯度为93%±3%（V/V），符合美国药典USP-93O2标准和国家药品食品监督局颁布的YY/T0298-1998《医用分子筛制氧设备通用技术规范》。
          </p>
          <p>
            4、触摸屏智能显示，可随时查看系统运行参数，如氧气纯度、氧气流量、氧气压力等设备运行参数。
          </p>
          <p>5、氧气纯度、流量、压力在线监测，信号输出显示。</p>
          <p>6、氧气纯度不合格、氧气压力欠压时声光报警。</p>
          <p>7、冷冻干燥机、过滤器自动排污。</p>
          <p>
            8、正常维护和使用下，该系统保用10年以上，终身维护，有完善的售后服务保障。
          </p>
          <p>
            9、根据医院的临床实际用氧量配置2-3套设备，医院中心供氧站的汇流排或液态氧系统作为备用系统，确保医院临床用氧。
          </p>
          <p>10、整个系统采用不锈钢制造，抗氧化，符合国家药品GMP生产要求。</p>
          <p>11、独特的静音式设计，使周围环境噪声低于45dB（A）。</p>
          <p><strong>医用中心制氧技术参数表 </strong></p>
          <table border="0" cellpadding="0" cellspacing="0">
            <tbody>
              <tr>
                <td rowspan="2"><p>型 号</p></td>
                <td rowspan="2"><p>产氧量（m3/h）</p></td>
                <td rowspan="2"><p>配置数量（套）</p></td>
                <td rowspan="2"><p>适用病床数（张）</p></td>
                <td colspan="2"><p>适用月用氧量</p></td>
              </tr>
              <tr>
                <td><p>瓶装氧（瓶/月）</p></td>
                <td><p>液态氧（吨/月）</p></td>
              </tr>
              <tr>
                <td><p>AO-3</p></td>
                <td><p>3</p></td>
                <td><p>2</p></td>
                <td><p>300</p></td>
                <td><p>200</p></td>
                <td><p>1~2</p></td>
              </tr>
              <tr>
                <td><p>AO-6</p></td>
                <td><p>6</p></td>
                <td><p>2</p></td>
                <td><p>300~400</p></td>
                <td><p>300</p></td>
                <td><p>3</p></td>
              </tr>
              <tr>
                <td><p>AO-6+</p></td>
                <td><p>7</p></td>
                <td><p>2</p></td>
                <td><p>400~500</p></td>
                <td><p>400~600</p></td>
                <td><p>4~6</p></td>
              </tr>
              <tr>
                <td><p>AO-10</p></td>
                <td><p>10</p></td>
                <td><p>2</p></td>
                <td><p>500</p></td>
                <td><p>700~800</p></td>
                <td><p>7~8</p></td>
              </tr>
              <tr>
                <td><p>AO-15</p></td>
                <td><p>15</p></td>
                <td><p>2</p></td>
                <td><p>500~600</p></td>
                <td><p>900~1200</p></td>
                <td><p>9~10</p></td>
              </tr>
              <tr>
                <td><p>AO-20</p></td>
                <td><p>20</p></td>
                <td><p>2</p></td>
                <td><p>800~1000</p></td>
                <td><p>1300~1600</p></td>
                <td><p>12~15</p></td>
              </tr>
              <tr>
                <td><p>AO-30</p></td>
                <td><p>30</p></td>
                <td><p>2</p></td>
                <td><p>1200</p></td>
                <td><p>1800~2400</p></td>
                <td><p>18~25</p></td>
              </tr>
              <tr>
                <td><p>AO-40</p></td>
                <td><p>40</p></td>
                <td><p>2</p></td>
                <td><p>1400</p></td>
                <td><p>2600~3200</p></td>
                <td><p>26~32</p></td>
              </tr>
              <tr>
                <td><p>AO-50</p></td>
                <td><p>50</p></td>
                <td><p>2</p></td>
                <td><p>2000</p></td>
                <td><p>3500~5000</p></td>
                <td><p>40~45</p></td>
              </tr>
              <tr>
                <td><p>AO-60</p></td>
                <td><p>60</p></td>
                <td><p>2</p></td>
                <td><p>2400</p></td>
                <td><p>3800~6000</p></td>
                <td><p>50~55</p></td>
              </tr>
            </tbody>
          </table>
          <p>注：部分医院根据用氧需求，可同时安装更多套数设备。</p>
        </template>
      </div>
    </div>
    <div slot="footer" />
  </el-dialog>
</template>

<script>
export default {
  props: {
    dialogVisible: Boolean,
    selectedProduct: Object
  },
  data () {
    return {
      dialogVisibleLocal: false
    }
  },
  watch: {
    dialogVisible: {
      immediate: true,
      handler (newValue) {
        this.dialogVisibleLocal = newValue
      }
    }
  },
  methods: {
    closeDialog () {
      this.dialogVisibleLocal = false
      this.$emit('update:dialogVisible', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.details {
  display: flex;
  flex-direction: column;
  .details_img {
    width: 100%;
    height: 440px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #fff;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    .img{
      max-width: 100%;
      height: auto;
      img{
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
      }
    }
  }
  .details_c {
    flex: 1;
    // margin-left: 20px;
    margin-top: 20px;
    font-size: 16px;
    color: #6a6a6a;
    p {
      // margin-top: 30px;
      line-height: 25px;
      // text-indent:40px;
    }
    h2{
      font-weight: bold;
      color: #000000;
      margin-bottom: 10px;
    }
  }
}
em {
  color: #3366ff;
}
.dialogStyle{
  /deep/ .el-dialog{
    .el-dialog__body{
      height: 760px;
      overflow-y: auto;
    }
  }
}
</style>
